import React from 'react';
import { BlockedSignal } from '../../../types/monitor.types';
import { formatTimeUTC6, formatDateTimeUTC6 } from '../../../utils/formatters';

interface Props {
  signals: BlockedSignal[];
  showDate?: boolean;
}

const reasonClass = (reason: string): string => {
  const r = reason.toLowerCase();
  if (r.includes('counter')) return 'reason-counter';
  if (r.includes('ema9') || r.includes('distance')) return 'reason-distance';
  if (r.includes('cooldown')) return 'reason-cooldown';
  return 'reason-other';
};

const BlockedSignals: React.FC<Props> = ({ signals, showDate = false }) => {
  if (signals.length === 0) {
    return (
      <div className="blocked-signals-section">
        <p className="blocked-signals-empty">No blocked signals today</p>
      </div>
    );
  }

  return (
    <div className="blocked-signals-section">
      <div className="blocked-signals-header">
        <span className="blocked-count">{signals.length} blocked</span>
      </div>
      <div className="blocked-signals-table-wrap">
        <table className="blocked-signals-table">
          <thead>
            <tr>
              <th>Time</th>
              <th>Model</th>
              <th>Dir</th>
              <th>Event</th>
              <th>Score</th>
              <th>Reason</th>
            </tr>
          </thead>
          <tbody>
            {signals.map((s, i) => {
              const time = showDate ? formatDateTimeUTC6(s.timestamp) : formatTimeUTC6(s.timestamp);
              return (
                <tr key={i}>
                  <td className="td-mono">{time}</td>
                  <td className="td-model">{s.model}</td>
                  <td>
                    <span className={`dir-tag ${s.direction === 'BUY' ? 'dir-buy' : 'dir-sell'}`}>
                      {s.direction}
                    </span>
                  </td>
                  <td className="td-event">{s.eventType}</td>
                  <td className="td-mono">{s.score.toFixed(2)}</td>
                  <td><span className={`reason-badge ${reasonClass(s.reason)}`}>{s.reason}</span></td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default BlockedSignals;
